export default __webpack_public_path__ + "static/vertical-thumbnail-1-3979be482ffa30b2c9e2508decc749b2.jpg";